import { fetchAuthSessionWithLoginMismatchRetry } from "./amplifyAuthRecovery";

// The signed-in user's Cognito access token for the native apps' session log
// upload (docs/app-log-uploads.md): the stream window sends it along with the
// log when the stream ends, so the upload says who streamed. null when signed
// out (camera links): the stream key is enough then. Pass it to the native
// window only; never log or track it.
export const logUploadToken = async () => {
  try {
    const session = await fetchAuthSessionWithLoginMismatchRetry();
    return session?.tokens?.accessToken?.toString() || null;
  } catch (error) {
    return null;
  }
};
